import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { DevicesNotificationFileTypes } from 'types';
import { dropboxPushFileTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';

interface IFileTypeSelect {
	setDropboxPushFileType: (value: DevicesNotificationFileTypes | null) => void;
}

const FileTypeSelect: React.FC<IFileTypeSelect> = ({ setDropboxPushFileType }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectFileType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return dropboxPushFileTypes.map((el) => ({ id: el, name: el }));
	}, [dropboxPushFileTypes]);

	return (
		<FormSelect
			testId="FileTypeSelect"
			name="selectedDropboxPushFileType"
			label="fileTypeLabel"
			options={mappedOptions}
			onChange={setDropboxPushFileType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(FileTypeSelect);
